/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input, Spin, Table, Tooltip, Empty } from 'antd';
import { Loader } from 'components/Global';
import MessageModal from 'components/Global/MessageModal';
import { useCallback, useEffect, useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { classAction, classOptionsAction } from 'redux/action/classAction';
import { getConfiguration } from 'redux/action/configurationAction';
import {
	getCostAllocationAction,
	getPaginationCostAllocationAction,
} from 'redux/action/costAllocationAction';
import {
	customerAccountAction,
	customerOptionsAction,
} from 'redux/action/customerAction';
import { getEmployeeAction } from 'redux/action/employeeAction';
import { getEmployeeCostColumnAction } from 'redux/action/employeeCostColumnSlice';
import { getApi, postApi, putApi } from 'redux/apis';
import { clearCostAllocationRedux } from 'redux/slice/costAllocationSlice';
import { AppDispatch } from 'redux/store';
import { useDebounce } from 'use-debounce';
import { ClockSvg, SortSvgBottom, SortSvgTop } from 'utils/svgs';
import {
	checkPermission,
	convertToHyphenCase,
	hasText,
	toastText,
} from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { CostAllocationTableProps } from './types';
import { CostAllocationDifferenceModal } from '../WarningModal';
import { updateNotIncludedEmployeeIds } from 'redux/slice/employeeCostSlice';
import { InputEditWarningModal } from '../InputEditWarningModal';
import {
	DownCircleOutlined,
	LoadingOutlined,
	PercentageOutlined,
} from '@ant-design/icons';
import { EmployeeConfigModal } from 'components/EmployeeCost/EmployeeConfigModal';
import { locationOptionsAction } from 'redux/action/locationAction';
// import Ellipse from 'components/Global/Ellipse';
import WrappingEllipse from '../Ellipse';
import { companyAbortController } from 'utils/abortController';
import { ResolveClassReferencesModal } from '../ResolveClassReferencesModal';
import { WarningOutlined } from '@ant-design/icons';

const FIXED_COLUMNS = ['Employee Name', 'Customer Name', 'Class Name'];
const useLoadingMessages = () => {
	const [messageIndex, setMessageIndex] = useState(0);

	const loadingMessages = [
		'Fetching employees...',
		'Loading employee costs...',
		'Retrieving time activities...',
		'Processing cost allocations...',
		'Calculating totals...',
	];

	useEffect(() => {
		const interval = setInterval(() => {
			setMessageIndex((prevIndex) => (prevIndex + 1) % loadingMessages.length);
		}, 3000);

		return () => clearInterval(interval);
	}, []);

	return loadingMessages[messageIndex];
};
const DynamicTable = (props: CostAllocationTableProps) => {
	const {
		handlePayPeriodId,
		searchValue,
		setSearchValue,
		filterValue,
		setFilterValue,
		sortBy,
		setSortBy,
		sortType,
		setSortType,
		isCostAllocation,
		onScreenChange,
		isExpanded,
	} = props;

	const { Column } = Table;
	const dispatch = useDispatch<AppDispatch>();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const navigate = useNavigate();

	const { data: sectionWiseFields } = useSelector(
		(state: any) => state?.employeeCostColumns
	);

	const { optionData: payPeriods, isPayPeriodOptionFetched } = useSelector(
		(state: any) => state?.payPeriods
	);

	const payrollMethod = useSelector(
		(state: any) => state?.companies?.configurations?.payrollMethod
	);

	const {
		count,
		costAllocationData,
		employeeRowSpanMapping,
		currentDatePayPeriod,
		error: costAllocationError,
		// hasCostAllocationData
	} = useSelector((state: any) => state?.costAllocation);

	const { dataChanged } = useSelector((state: any) => state?.chatBubble);

	const [queryParams, setQueryParams] = useSearchParams();
	const [initalCostAllocationData, setInitalCostAllocationData] =
		useState(costAllocationData);

	const [payPeriodId, setPayPeriodId] = useState<string | null>(
		queryParams.get('payPeriod') || localStorage.getItem('payPeriod') || null
	);

	const [showWarningModel, setShowWarningModel] = useState(false);
	const [showInputEditWarningModel, setShowInputEditWarningModel] =
		useState(false);
	const [increaseValueWarningModel, setIncreaseValueWarningModel] =
		useState(false);
	const [infoWarningModel, setInfoWarningModel] = useState(false);
	const [configurationMismatchModel, setConfigurationMismatchModel] =
		useState(false);

	const [currentChangeDetails, setCurrentChangeDetails] = useState<{
		columnId: string;
		newValue: string;
		record: any;
		originalValue: string;
	} | null>(null);

	const [isLoading, setIsLoading] = useState(false);

	const [originalValue, setOriginalValue] = useState<{ [key: string]: any }>(
		{}
	);
	const currentLoadingMessage = useLoadingMessages();

	// const tableRef = useRef<HTMLDivElement>(null);
	const [isInViewPort, setIsInViewPort] = useState<boolean>(false);
	const [columns, setColumns] = useState([]);

	const [debounceSearchValue] = useDebounce(searchValue, 1000);
	const [applySearch, setApplySearch] = useState<boolean>(false);

	const [isConfigModalOpen, setISConfigModalOpen] = useState(false);
	const [selectedEmployeeConfig, setSelectedEmployeeConfig] =
		useState<any>(null);
	const [
		openCostAllocationDifferenceModal,
		setOpenCostAllocationDifferenceModal,
	] = useState(false);

	const [costAllocationDifferenceData, setCostAllocationDifferenceData] =
		useState<any>(null);

	// CAP-94: track employees whose cost allocation still points at a QBO
	// class that's since been renamed/merged away, so we can warn before the
	// admin hits the same publish-time block.
	const [classReferenceIssues, setClassReferenceIssues] = useState<any[]>([]);
	const [isResolveModalOpen, setIsResolveModalOpen] = useState(false);

	const [pageNo, setPageNo] = useState(1);

	const { selectedCompanyDetails } = useSelector(
		(state: any) => state.companies
	);

	const { data: configurationsData } = useSelector(
		(state: any) => state?.configuration
	);

	const colorArray = ['cell-fff', 'cell-e7eff8', 'cell-e1f1eb', 'cell-f3ede7'];

	const sortData = {
		showSorterTooltip: { title: '' },
		defaultSortOrder: 'ascend',
		sorter: () => {
			return null as any;
		},
		sortDirections: ['ascend', 'descend', 'ascend'],
		sortIcon: (data: any) => {
			return data.sortOrder === 'ascend' ? <SortSvgTop /> : <SortSvgBottom />;
		},
	};

	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);

	const isAddEmployeeCostPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Employee Cost',
			permission: ['add'],
		}
	);

	const isEditEmployeeCostPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Employee Cost',
			permission: ['edit'],
		}
	);

	const [totalRow, setTotalRow] = useState<any>(null);

	useEffect(() => {
		if (costAllocationData && sectionWiseFields) {
			// Calculate total labor burden for each record
			const dataWithLaborBurden = recalculateAllTotalLaborBurden(costAllocationData);
			setInitalCostAllocationData(dataWithLaborBurden);
		} else {
			setInitalCostAllocationData(costAllocationData);
		}
	}, [costAllocationData, sectionWiseFields]);

	// An AI-chat-confirmed employee add/cost-update elsewhere in the app has no
	// other way to reach this table — re-run our own existing fetch (which
	// already knows our current filters/sort/page) rather than guessing its
	// query params from outside.
	useEffect(() => {
		if (!dataChanged || dataChanged.scope !== 'costAllocation') {
			return;
		}
		if (dataChanged.companyId !== localStorage.getItem('companyId')) {
			return;
		}
		if (dataChanged.payPeriodId && dataChanged.payPeriodId !== payPeriodId) {
			return;
		}
		getCostAllocationData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataChanged]);

	// Recalculate total labor burden when section fields or configurations change
	useEffect(() => {
		if (initalCostAllocationData && initalCostAllocationData.length > 0 && sectionWiseFields && configurationsData) {
			const dataWithRecalculatedLaborBurden = recalculateAllTotalLaborBurden(initalCostAllocationData);
			setInitalCostAllocationData(dataWithRecalculatedLaborBurden);
		}
	}, [sectionWiseFields, configurationsData]);

	// Get total employee-cost total

	// Function to calculate total labor burden for cost allocation data
	const calculateTotalLaborBurden = (record: any) => {
		let total = 0;

		// Sum up all section fields (excluding employee type and hours fields)
		sectionWiseFields?.forEach((singleSection: any) => {
			if (singleSection.no !== 0) {
				singleSection.fields.forEach((singleField: any) => {
					if (singleField.isActive && singleField.jsonId === 't1') {
						const value = Number(record[singleField.id] || 0);
						total += value;
					}
				});
			}
		});

		// Add indirect allocation values
		Object.keys(record).forEach((key) => {
			if (key.startsWith('indirect-allocation-')) {
				const value = Number(record[key] || 0);
				total += value;
			}
		});

		return total.toFixed(configurationsData?.decimalToFixedAmount || 2);
	};

	// Function to recalculate total labor burden for all records
	const recalculateAllTotalLaborBurden = (data: any[]) => {
		return data.map((record: any) => ({
			...record,
			totalLaborBurden: calculateTotalLaborBurden(record)
		}));
	};

	useEffect(() => {
		return () => {
			dispatch(clearCostAllocationRedux());
		};
	}, []);

	useEffect(() => {
		dispatch(
			getConfiguration({
				payPeriodId,
			})
		);

		dispatch(
			getEmployeeCostColumnAction({
				payPeriodId,
			})
		);

		getCostAllocationActionDifference();
		// if (payPeriodId) {
		// }
	}, [payPeriodId]);

	useEffect(() => {
		if (selectedCompanyDetails && payPeriods && isPayPeriodOptionFetched) {
			let _payPeriodId: string | null = null;
			if (payPeriods.length) {
				if (
					payPeriods[payPeriods.length - 1].companyId ===
					selectedCompanyDetails.companyId
				) {
					_payPeriodId = payPeriodId;
					if (_payPeriodId) {
						const payPeriodData = payPeriods.find(
							(e: any) => e.id === payPeriodId
						);
						if (
							!payPeriodData ||
							payPeriodData.companyId != selectedCompanyDetails.companyId
						) {
							_payPeriodId = payPeriods[payPeriods.length - 1]?.id || null;
						}
					} else {
						_payPeriodId = payPeriods[payPeriods.length - 1]?.id || null;
					}
					dispatch(classAction());
					dispatch(classOptionsAction());
					dispatch(customerAccountAction());
					dispatch(customerOptionsAction());
					dispatch(locationOptionsAction());
					dispatch(getEmployeeAction());
					setPayPeriodId(_payPeriodId);
					localStorage.setItem('payPeriod', _payPeriodId as string);
					if (_payPeriodId) {
						setQueryParams({ payPeriodId: _payPeriodId as string });
					}
					setApplySearch(true);
				}
			} else {
				if (_payPeriodId) {
					setQueryParams({ payPeriodId: _payPeriodId as string });
					localStorage.setItem('payPeriod', _payPeriodId as string);
				}
				dispatch(classAction());
				dispatch(classOptionsAction());
				dispatch(customerAccountAction());
				dispatch(customerOptionsAction());
				dispatch(locationOptionsAction());
				dispatch(getEmployeeAction());
				setPayPeriodId(_payPeriodId);
				if (_payPeriodId) {
					setQueryParams({ payPeriodId: _payPeriodId as string });
				}
				setApplySearch(true);
			}
		}
	}, [selectedCompanyDetails, payPeriods, isPayPeriodOptionFetched]);

	useEffect(() => {
		if (currentDatePayPeriod) {
			setPayPeriodId(currentDatePayPeriod);
			localStorage.setItem('payPeriod', currentDatePayPeriod as string);
		}
	}, [currentDatePayPeriod]);

	useEffect(() => {
		if (
			costAllocationError &&
			costAllocationError?.message === 'Invalid PayPeriod' &&
			hasText(payPeriodId)
		) {
			navigate('/unauthorized');
		}
	}, [costAllocationError]);

	useEffect(() => {
		if (payPeriodId) {
			handlePayPeriodId(payPeriodId);
		}
	}, [payPeriodId]);

	useEffect(() => {
		if (applySearch) {
			getCostAllocationData();
		}
	}, [
		payPeriodId,
		debounceSearchValue,
		filterValue,
		sortBy,
		sortType,
		selectedCompanyDetails,
		payPeriods,
		isPayPeriodOptionFetched,
	]);

	useEffect(() => {
		const tableBody = document.querySelector('.ant-table-body');
		tableBody?.addEventListener('scroll', scrollHandler);
		return () => {
			// Remove scroll event listener when component unmounts
			tableBody?.removeEventListener('scroll', scrollHandler);
		};
	}, [costAllocationData]);

	useEffect(() => {
		(async () => {
			if (
				isInViewPort &&
				employeeRowSpanMapping &&
				Object.keys(employeeRowSpanMapping).filter((e) => hasText(e)).length <
				count
			) {
				await getCostAllocationData(true);
			}
		})();
	}, [isInViewPort]);

	useEffect(() => {
		const finalColumns: any = [
			{
				isSectionLastColumn: true,
				className: 'employee-name',
				cellColor: 'cell-fff',
				sectionId: '',
				sectionName: '',
				fieldId: '',
				fieldName: 'Employee Name',
				fieldType: 'Text',
				isCalculatorNeeded: false,
				isDollarNeeded: false,
				isHours: false,
				total: false,
				title: 'Employee Name',
				dataIndex: 'employee-name',
				key: Math.random(),
				width: 200,
				isHoursSetup: false,
				...sortData,
			},
			{
				isSectionLastColumn: false,
				className: 'customer-name',
				cellColor: 'cell-fff',
				sectionId: '',
				sectionName: '',
				fieldId: '',
				fieldName: 'Customer Name',
				fieldType: 'Text',
				isCalculatorNeeded: false,
				isDollarNeeded: false,
				isHours: false,
				total: false,
				title: 'Customer Name',
				dataIndex: 'customer-name',
				key: Math.random(),
				width: 200,
				isHoursSetup: false,
			},
			{
				isSectionLastColumn: true,
				className: 'class-name',
				cellColor: 'cell-fff',
				sectionId: '',
				sectionName: '',
				fieldId: '',
				fieldName: 'Class Name',
				fieldType: 'Text',
				isCalculatorNeeded: false,
				isDollarNeeded: false,
				isHours: false,
				total: false,
				title: 'Class Name',
				dataIndex: 'class-name',
				key: Math.random(),
				width: 200,
				isHoursSetup: false,
			},
			{
				isSectionLastColumn: false,
				className: 'total-hours',
				cellColor: 'cell-FCF9E1',
				sectionId: '',
				sectionName: '',
				fieldId: '',
				fieldName: 'Total Hours',
				fieldType: 'Text',
				isCalculatorNeeded: false,
				isDollarNeeded: false,
				isHours: false,
				total: false,
				title: 'Total Hours',
				dataIndex: 'total-hours',
				key: Math.random(),
				width: 100,
				isHoursSetup: false,
			},
			{
				isSectionLastColumn: true,
				className: 'allocation',
				cellColor: 'cell-FCF9E1',
				sectionId: '',
				sectionName: '',
				fieldId: '',
				fieldName: 'Allocation',
				fieldType: 'Text',
				isCalculatorNeeded: false,
				isDollarNeeded: false,
				isHours: false,
				total: false,
				title: 'Allocation%',
				dataIndex: 'allocation',
				key: Math.random(),
				width: 150,
				isHoursSetup: false,
			},
		];
		// (payrollMethod === 'Percentage' && singleSection.no === 0)
		sectionWiseFields?.map((singleSection: any, sectionIndex: number) => {
			singleSection?.fields?.map((singleField: any, index: number) => {
				if (singleSection.no != 0 && singleField.isActive) {
					finalColumns.push({
						svg:
							sectionIndex === 0 && (index === 1 || index === 2) ? (
								<ClockSvg />
							) : null,
						cellWidth:
							sectionIndex === 0 && (index === 1 || index === 2) ? 130 : 90,
						className: convertToHyphenCase(singleField.name),
						sectionId: singleSection?.id,
						sectionName: singleSection?.sectionName,
						fieldId: singleField?.id,
						fieldName: singleField?.name,
						fieldType:
							singleField?.name == 'Employee Type' ? 'Select' : 'Number',
						isCalculatorNeeded:
							singleSection?.sectionName == 'Employee Type' ||
								payrollMethod === 'Percentage'
								? false
								: true,
						isDollarNeeded:
							singleSection?.sectionName == 'Employee Type' ? false : true,
						isHours:
							singleField?.name == 'Maximum allocate hours per year'
								? true
								: singleField?.name == 'Maximum Vacation/PTO hours per year'
									? true
									: false,
						total: false,
						title: singleField?.name,
						dataIndex: singleField?.id, //name?.split(' ').join('-').toLowerCase()
						cellColor: colorArray[sectionIndex],
						isSectionLastColumn:
							index === singleSection?.fields.length - 1 ? true : false,
						key: singleField?.id,
						width:
							singleField?.name == 'Employee Type'
								? 250
								: singleField?.name == 'Maximum allocate hours per year'
									? 210
									: singleField?.name == 'Maximum Vacation/PTO hours per year'
										? 250
										: 140,
						status: singleField?.active,

						isHoursSetup: singleSection?.no == 0,
					});
				}
			});
		});

		// finalColumns.push({
		// 	isSectionLastColumn: false,
		// 	className: 'indirect-allocation',
		// 	cellColor: 'cell-DFE9ED',
		// 	sectionId: '',
		// 	sectionName: '',
		// 	fieldId: '',
		// 	fieldName: 'Indirect Allocation',
		// 	fieldType: 'Number',
		// 	isCalculatorNeeded: false,
		// 	isDollarNeeded: false,
		// 	isHours: false,
		// 	total: false,
		// 	title: 'Indirect Allocation',
		// 	dataIndex: 'indirect-allocation',
		// 	key: Math.random(),
		// 	width: 150,
		// 	isHoursSetup: false,
		// });

		const indirectAllocationKeys = new Set<string>();
		(costAllocationData || []).slice(0, 5).forEach((record: any) => {
			Object.keys(record).forEach((key) => {
				if (key.startsWith('indirect-allocation-')) {
					indirectAllocationKeys.add(key);
				}
			});
		});

		// Convert to array to get the last element
		const indirectAllocationKeysArray = Array.from(indirectAllocationKeys);

		indirectAllocationKeysArray.forEach((key, index) => {
			finalColumns.push({
				className: key,
				cellColor: 'cell-DFE9ED',
				title: key
					.replace('indirect-allocation-', '')
					.replace(/-/g, ' ')
					.replace(/\b\w/g, (c) => c.toUpperCase()),
				dataIndex: [key],
				key,
				width: 150,
				fieldType: 'Number',
				isHoursSetup: false,
				isSectionLastColumn: index === indirectAllocationKeysArray.length - 1, // true for last indirect allocation column
			});
		});

		// Add Total Labor Burden column
		finalColumns.push({
			isSectionLastColumn: true,
			className: 'total-labor-burden',
			cellColor: 'cell-FCF9E1',
			sectionId: '',
			sectionName: '',
			fieldId: '',
			fieldName: 'Total Labor Burden',
			fieldType: 'Number',
			isCalculatorNeeded: false,
			isDollarNeeded: true,
			isHours: false,
			total: true,
			title: 'Total Labor Burden',
			dataIndex: 'totalLaborBurden',
			key: 'total-labor-burden',
			width: 200,
			isHoursSetup: false,
		});

		setColumns(finalColumns);
	}, [sectionWiseFields, payrollMethod, costAllocationData, configurationsData]);

	const scrollHandler = useCallback((event: any) => {
		const { currentTarget } = event;
		const tableBody = currentTarget?.querySelector('tbody');
		if (
			tableBody?.getBoundingClientRect().top +
			tableBody.getBoundingClientRect().height <
			screen.height - 100
		) {
			setIsInViewPort(true);
		} else {
			setIsInViewPort(false);
		}
	}, []);

	const getCostAllocationData = async (isPageable?: boolean) => {
		const requestKey = 'getCostAllocation';
		const { controller, requestId } =
			companyAbortController.createController(requestKey);

		// Only set loading if this is the latest request
		if (companyAbortController.isLatestRequest(requestKey, requestId)) {
			setIsLoading(true);
		}

		if (isPageable) {
			setPageNo((prev: any) => prev + 1);
		} else {
			setPageNo(1);
			setTotalRow(null);
		}

		const query: any = {
			page: isPageable ? pageNo + 1 : 1,
			limit: 10,
			search: searchValue,
			payPeriodId,
			sort: sortBy,
			type: sortType,
			...filterValue,
			signal: controller.signal,
		};

		// Handle employeeId as array - convert to comma-separated string for API
		if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
			query.employeeId = query.employeeId.join(',');
		} else {
			// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
			delete query.employeeId;
		}

		// Handle customerId as array - convert to comma-separated string for API
		if (Array.isArray(query.customerId) && query.customerId.length > 0) {
			query.customerId = query.customerId.join(',');
		} else {
			// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
			delete query.customerId;
		}

		// Handle classId as array - convert to comma-separated string for API
		if (Array.isArray(query.classId) && query.classId.length > 0) {
			query.classId = query.classId.join(',');
		} else {
			// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
			delete query.classId;
		}

		if (!hasText(searchValue)) {
			delete query.search;
		}

		// Use default sort if not specified
		if (!hasText(query.sort)) {
			query.sort = 'fullName';
		}

		if (!hasText(query.type)) {
			query.type = 'asc';
		}

		try {
			if (isPageable) {
				const res = await dispatch(getPaginationCostAllocationAction(query));
				if (companyAbortController.isLatestRequest(requestKey, requestId)) {
					// Process results only if this is still the latest request
					if (res?.payload && !res?.payload?.error) {
						// Results processed
					}
				}
				companyAbortController.cleanupRequest(requestKey);
				return;
			}

			const res = await dispatch(getCostAllocationAction(query));

			if (companyAbortController.isLatestRequest(requestKey, requestId)) {
				// Process results only if this is still the latest request
				if (res?.payload && !res?.payload?.error) {
					// Fetch total row only if main request succeeded
					try {
						// eslint-disable-next-line @typescript-eslint/no-unused-vars
						const { signal: _, ...totalRowQuery } = query;
						const totalRowRes = await getApi(
							'/cost-allocation/total-row',
							{
								...totalRowQuery,
								companyId: localStorage.getItem('companyId'),
							},
							controller.signal
						);
						if (companyAbortController.isLatestRequest(requestKey, requestId)) {
							setTotalRow(totalRowRes.data?.data);
						}
					} catch (err: any) {
						if (err.name === 'AbortError') {
							// Request was aborted, do nothing
							return;
						}
						if (err?.response?.data?.error?.status == 401) {
							navigate('/login');
							window.location.reload();
						}
					}
				}
			}
		} catch (err: any) {
			if (err.name === 'AbortError') {
				// Request was aborted, do nothing
				console.log('Request aborted, new request in progress...');
				return;
			}
			console.error('API Error:', err);
			if (companyAbortController.isLatestRequest(requestKey, requestId)) {
				setIsLoading(false);
			}
		} finally {
			if (companyAbortController.isLatestRequest(requestKey, requestId)) {
				setIsLoading(false);
				setApplySearch(false);
			}
			companyAbortController.cleanupRequest(requestKey);
		}
	};

	const tableChangeHandler = (_: unknown, __: unknown, tableData: any) => {
		if (tableData.field && tableData.order) {
			setApplySearch(true);
			setSortBy('fullName');
			setSortType(tableData.order === 'ascend' ? 'asc' : 'desc');
		}
	};

	const handleConfigure = () => {
		dispatch(
			updateNotIncludedEmployeeIds({
				notIncludedEmployeeIds:
					costAllocationDifferenceData.notFoundAllocationEmployeesIDs,
			})
		);
		navigate('/employee-costs');
	};

	// CAP-94: read-only check, doesn't write anything — safe to call on every
	// pay period change alongside the existing cost allocation load.
	const getClassReferenceStatus = async () => {
		if (!payPeriodId) {
			return;
		}

		try {
			const res = await getApi('/employee-config/class-reference-status', {
				companyId: localStorage.getItem('companyId'),
				payPeriodId,
			});
			const issues = (res?.data?.data || []).filter(
				(issue: any) => issue.status !== 'ok'
			);
			setClassReferenceIssues(issues);
		} catch (err) {
			// Non-critical — don't block the page over this check failing.
			setClassReferenceIssues([]);
		}
	};

	useEffect(() => {
		getClassReferenceStatus();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [payPeriodId]);

	const staleClassEmployeeIds = new Set(
		classReferenceIssues.map((issue: any) => issue.employeeId)
	);

	const getCostAllocationActionDifference = async () => {
		try {
			const res = await getApi('/cost-allocation/difference', {
				payPeriodId,
				companyId: localStorage.getItem('companyId'),
			});

			const data = res.data?.data;
			if (!data) {
				setOpenCostAllocationDifferenceModal(false);
				return;
			}

			const {
				totalEmployeeCostWithoutIndirectRate,
				totalAllocation,
				notFoundAllocationEmployeesName,
				totalEmployeeCost,
				notFoundAllocationEmployeesIDs,
			} = data;

			const formattedEmployeeCost = Number(
				totalEmployeeCostWithoutIndirectRate?.toFixed(2)
			);
			const formattedAllocation = Number(totalAllocation?.toFixed(2));

			if (
				totalEmployeeCostWithoutIndirectRate &&
				totalAllocation &&
				formattedEmployeeCost !== formattedAllocation
			) {
				setCostAllocationDifferenceData({
					employees: notFoundAllocationEmployeesName,
					totalAllocation,
					totalEmployeeCostWithoutIndirectRate,
					totalEmployeeCost,
					notFoundAllocationEmployeesIDs,
				});
				setOpenCostAllocationDifferenceModal(true);
			} else {
				setOpenCostAllocationDifferenceModal(false);
			}
		} catch (err: any) {
			if (err?.response?.data?.error?.status == 401) {
				navigate('/login');
				window.location.reload();
			}
		}
	};

	const handleOnValueChange = (key: string, value: string, record: any) => {
		const tempCopy = JSON.parse(JSON.stringify(costAllocationData));
		const newValue = hasText(value) ? value : 0;

		const rowIndex = tempCopy.findIndex((item: any) => item.id === record.id);

		if (rowIndex !== -1) {
			tempCopy[rowIndex][key] = newValue;

			// Recalculate total labor burden for the updated record
			tempCopy[rowIndex].totalLaborBurden = calculateTotalLaborBurden(tempCopy[rowIndex]);

			setInitalCostAllocationData(tempCopy);
		}
	};

	const handleOnFocus = (record: any, columnKey: string) => {
		const value = record[columnKey];
		const key = `${record.id}-${columnKey}`;

		setOriginalValue((prev) => {
			// Only set the original value if it's not already stored
			if (!(key in prev)) {
				return { ...prev, [key]: value };
			}
			return prev; // Keep the existing original value
		});
	};

	const handleInputBlur = (columnId: string, newValue: string, record: any) => {
		const tempCopy = JSON.parse(JSON.stringify(costAllocationData));
		const newValueFloat = parseFloat(newValue);
		// const originalValueFloat = parseFloat(originalValue);
		const originalValueFloat = parseFloat(
			originalValue[`${record.id}-${columnId}`]
		);

		// Get all related records for this employee
		const relatedRecords = tempCopy.filter(
			(item: any) => item.employeeId === record.employeeId
		);

		// Get total record if exists
		const totalRecord = relatedRecords.find(
			(item: any) => item.type === 'total'
		);
		const totalValue = totalRecord ? totalRecord[columnId] : 0;

		// For negative numbers, we need to compare absolute values
		const isWithinTotal = newValueFloat <= totalValue;

		const hasValueChanged = newValueFloat !== originalValueFloat;
		const hasRequiredConfigs =
			configurationsData.isCustomerRequiredForJournal ||
			configurationsData.isClassRequiredForJournal;

		// First condition - if either configuration is required
		if (hasRequiredConfigs && hasValueChanged && isWithinTotal) {
			setCurrentChangeDetails({
				columnId,
				newValue,
				record,
				originalValue: originalValue[`${record.id}-${columnId}`] || '',
			});
			setConfigurationMismatchModel(true);
			return;
		}

		// Second condition - only if no configurations are required
		if (hasValueChanged && isWithinTotal && !hasRequiredConfigs) {
			setCurrentChangeDetails({
				columnId,
				newValue,
				record,
				originalValue: originalValue[`${record.id}-${columnId}`] || '',
			});
			setShowInputEditWarningModel(true);
			return;
		}

		// Third condition - value exceeds total (2 records)
		if (!isWithinTotal && relatedRecords.length === 2 && hasValueChanged) {
			setCurrentChangeDetails({
				columnId,
				newValue,
				record,
				originalValue: originalValue[`${record.id}-${columnId}`] || '',
			});
			setIncreaseValueWarningModel(true);
			return;
		}

		// Fourth condition - value exceeds total (>2 records)
		if (!isWithinTotal && relatedRecords.length > 2 && hasValueChanged) {
			setCurrentChangeDetails({
				columnId,
				newValue,
				record,
				originalValue: originalValue[`${record.id}-${columnId}`] || '',
			});
			setInfoWarningModel(true);
			return;
		}
	};

	const handleChangeCostValue = async (
		columnId: string,
		newValue: string,
		record: any,
		isClassOrCustomerRequired = true
	) => {
		const tempCopy = JSON.parse(JSON.stringify(costAllocationData));
		const employeeId = record.employeeId;
		const newValueFloat = parseFloat(newValue);
		const originalValueFloat = parseFloat(
			originalValue[`${record.id}-${columnId}`]
		);

		const relatedRecords = tempCopy.filter(
			(item: any) => item.employeeId === employeeId
		);
		const totalRecord = relatedRecords.find(
			(item: any) => item.type === 'total'
		);
		const totalValue = totalRecord ? totalRecord[columnId] : 0;
		const nonTotalRecords = relatedRecords.filter(
			(item: any) => item.type !== 'total'
		);

		let finalArr = [];

		if (relatedRecords.length === 2) {
			if (newValueFloat <= originalValueFloat) {
				finalArr = nonTotalRecords.map((item: any) => ({
					key: item.id,
					employeeId: employeeId,
					value: item.id === record.id ? newValueFloat : item[columnId],
					columnId: columnId,
					type: null,
					customerName: item['customer-name'],
					customerId: item.customerId,
					className: item['class-name'],
					classId: item.classId,
					hasClassError: false,
					hasCustomerError: false,
				}));

				finalArr.push({
					key: Math.random(),
					employeeId: employeeId,
					value: originalValueFloat - newValueFloat,
					columnId: columnId,
					type: null,
					customerName: '-',
					customerId: '',
					className: '-',
					classId: '',
					hasClassError: false,
					hasCustomerError: false,
				});
			} else {
				const columnInfo = columns.find(
					(column: any) => column.dataIndex === columnId
				);
				if (!columnInfo) {
					console.log('Column information not found');
					return;
				}

				const { sectionId, isSectionLastColumn } = columnInfo;
				const sectionColumns = columns.filter(
					(column: any) => column.sectionId === sectionId
				);
				let sectionTotal = 0;

				sectionColumns.forEach((column: any) => {
					if (!column.isSectionLastColumn) {
						const value =
							column.fieldId === columnId
								? newValueFloat
								: record[column.fieldId]
									? parseFloat(record[column.fieldId])
									: 0;
						sectionTotal += value;
					}
				});

				const lastColumn: any = sectionColumns.find(
					(column: any) => column.isSectionLastColumn
				);
				if (lastColumn) {
					record[lastColumn.fieldId] = sectionTotal.toFixed(
						configurationsData?.decimalToFixedAmount || 2
					);
				}

				try {
					await putApi('/employee-cost/employee-cost-value', {
						employeeId,
						payPeriodId,
						value:
							Number(newValueFloat).toFixed(
								configurationsData?.decimalToFixedAmount || 2
							) || '0.00',
						fieldId: columnId,
						companyId: localStorage.getItem('companyId'),
						sectionId,
						isTotal: false,
					});

					if (!isSectionLastColumn && lastColumn) {
						await putApi('/employee-cost/employee-cost-value', {
							employeeId,
							payPeriodId,
							value: sectionTotal.toFixed(
								configurationsData?.decimalToFixedAmount || 2
							),
							fieldId: lastColumn.fieldId,
							companyId: localStorage.getItem('companyId'),
							sectionId,
							isTotal: true,
						});
					}
					return;
				} catch (error: any) {
					toastText(
						error?.response?.data?.message || 'Error while updating value',
						'error'
					);
				}
			}
		} else if (relatedRecords.length > 2) {
			const otherRecords = nonTotalRecords.filter(
				(item: any) => item.id !== record.id
			);
			const remainingValue = totalValue - newValueFloat;
			const valuePerRecord = remainingValue / otherRecords.length;

			finalArr = nonTotalRecords.map((item: any) => ({
				key: item.id,
				employeeId,
				value: item.id === record.id ? newValueFloat : valuePerRecord,
				columnId,
				type: null,
				customerName: item['customer-name'],
				customerId: item.customerId,
				className: item['class-name'],
				classId: item.classId,
				hasClassError: false,
				hasCustomerError: false,
			}));
		}

		const totalForAllocation = finalArr.reduce(
			(sum: number, record: any) => sum + Number(record.value),
			0
		);
		let runningTotal = 0;
		const recordsWithPercentages = finalArr.map((item: any, index: any) => {
			if (index < finalArr.length - 1) {
				const allocation = Number(
					((item.value / totalForAllocation) * 100).toFixed(2)
				);
				runningTotal += allocation;
				return {
					key: item.key,
					customerName: item.customerName,
					customerId: item.customerId,
					className: item.className,
					classId: item.classId,
					hasClassError: item.hasClassError,
					hasCustomerError: item.hasCustomerError,
					allocation,
					hours: allocation,
				};
			}
			return {
				key: item.key,
				customerName: item.customerName,
				customerId: item.customerId,
				className: item.className,
				classId: item.classId,
				hasClassError: item.hasClassError,
				hasCustomerError: item.hasCustomerError,
				allocation: Number((100 - runningTotal).toFixed(2)),
				hours: Number((100 - runningTotal).toFixed(2)),
			};
		});

		try {
			await postApi('/employee-config/create', {
				isActive: true,
				employeeId,
				payPeriodId,
				companyId: localStorage.getItem('companyId'),
				directAllocation: recordsWithPercentages,
				requireClassOrCustomer: isClassOrCustomerRequired,
			});
		} catch (error: any) {
			toastText(
				error?.response?.data?.message ||
				'Error while creating employee config',
				'error'
			);
		}
	};

	const handleProceed = async () => {
		if (currentChangeDetails) {
			try {
				setIsLoading(true);
				await handleChangeCostValue(
					currentChangeDetails.columnId,
					currentChangeDetails.newValue,
					currentChangeDetails.record
				);
				await getCostAllocationData();
			} catch (error) {
				toastText('An error occurred while updating data', 'error');
			} finally {
				setIsLoading(false);
				setShowInputEditWarningModel(false);
				setCurrentChangeDetails(null);
				setOriginalValue({});
			}
		}
	};

	const handleCancel = () => {
		if (currentChangeDetails) {
			const tempCopy = [...initalCostAllocationData];
			const rowIndex = tempCopy.findIndex(
				(item: any) => item.id === currentChangeDetails.record.id
			);
			if (rowIndex !== -1) {
				// Use the unique key for the specific column and row
				tempCopy[rowIndex][currentChangeDetails.columnId] =
					originalValue[
					`${currentChangeDetails.record.id}-${currentChangeDetails.columnId}`
					];
				setInitalCostAllocationData(tempCopy);
			}
		}
		setShowInputEditWarningModel(false);
		setCurrentChangeDetails(null);
		setOriginalValue({}); // Reset originalValues object
	};

	const handleUpdateCostProceed = async () => {
		if (currentChangeDetails) {
			try {
				setIsLoading(true);
				await handleChangeCostValue(
					currentChangeDetails.columnId,
					currentChangeDetails.newValue,
					currentChangeDetails.record
				);
				await getCostAllocationData();
			} catch (error) {
				toastText('An error occurred while updating data', 'error');
			} finally {
				setIsLoading(false);
				setIncreaseValueWarningModel(false);
				setCurrentChangeDetails(null);
				setOriginalValue({});
			}
		}
	};

	const handleUpdateCostCancel = () => {
		if (currentChangeDetails) {
			const tempCopy = [...initalCostAllocationData];
			const rowIndex = tempCopy.findIndex(
				(item: any) => item.id === currentChangeDetails.record.id
			);
			if (rowIndex !== -1) {
				tempCopy[rowIndex][currentChangeDetails.columnId] =
					originalValue[
					`${currentChangeDetails.record.id}-${currentChangeDetails.columnId}`
					];
				setInitalCostAllocationData(tempCopy);
			}
		}
		setIncreaseValueWarningModel(false);
		setCurrentChangeDetails(null);
		setOriginalValue({});
	};

	const handleInfoCancel = () => {
		if (currentChangeDetails) {
			const tempCopy = [...initalCostAllocationData];
			const rowIndex = tempCopy.findIndex(
				(item: any) => item.id === currentChangeDetails.record.id
			);
			if (rowIndex !== -1) {
				tempCopy[rowIndex][currentChangeDetails.columnId] =
					originalValue[
					`${currentChangeDetails.record.id}-${currentChangeDetails.columnId}`
					];
				setInitalCostAllocationData(tempCopy);
			}
		}
		setInfoWarningModel(false);
		setCurrentChangeDetails(null);
		setOriginalValue({});
	};

	const handleInfoProceed = async () => {
		handleInfoCancel();
	};

	const handleConfigurationMismatchCancel = () => {
		if (currentChangeDetails) {
			const tempCopy = [...initalCostAllocationData];
			const rowIndex = tempCopy.findIndex(
				(item: any) => item.id === currentChangeDetails.record.id
			);
			if (rowIndex !== -1) {
				tempCopy[rowIndex][currentChangeDetails.columnId] =
					originalValue[
					`${currentChangeDetails.record.id}-${currentChangeDetails.columnId}`
					];
				setInitalCostAllocationData(tempCopy);
			}
		}
		setConfigurationMismatchModel(false);
		setCurrentChangeDetails(null);
		setOriginalValue({});
	};

	const handleConfigurationMismatchProceed = async () => {
		if (currentChangeDetails) {
			try {
				setIsLoading(true);
				await handleChangeCostValue(
					currentChangeDetails.columnId,
					currentChangeDetails.newValue,
					currentChangeDetails.record,
					false
				);
				await getCostAllocationData();
			} catch (error) {
				toastText('An error occurred while updating data', 'error');
			} finally {
				setIsLoading(false);
				setConfigurationMismatchModel(false);
				setCurrentChangeDetails(null);
				setOriginalValue({});
			}
		}
	};


	const hasActiveFilters = Boolean(
		searchValue?.trim() ||
		filterValue?.employeeId?.length > 0 ||
		filterValue?.customerId?.length > 0 ||
		filterValue?.classId?.length > 0
	);

	const CustomEmptyState = () => (
		<Empty
			image={Empty.PRESENTED_IMAGE_SIMPLE}
			description={
				hasActiveFilters
					? "No Cost Allocation records match the selected filter criteria"
					: "No Cost Allocation records are currently available"
			}
			style={{
				padding: '40px 20px',
				margin: '20px 0'
			}}
		/>
	);

	const dataSource =
		totalRow && initalCostAllocationData
			? [...initalCostAllocationData, {
				...totalRow,
				totalLaborBurden: calculateTotalLaborBurden(totalRow)
			}]
			: initalCostAllocationData;

	const [showScrollToBottom, setShowScrollToBottom] = useState<boolean>(false);
	const tableScrollRef = useRef<any>(null);

	const handleTableScroll = () => {
		// Access the table body through the Ant Design table instance
		const tableBody = document.querySelector('.ant-table-body') as HTMLElement;
		if (tableBody) {
			const { scrollTop, scrollHeight, clientHeight } = tableBody;
			const isNearBottom = scrollTop + clientHeight >= scrollHeight - 10;
			setShowScrollToBottom(scrollTop > 200 && !isNearBottom);
		}
	};

	const scrollToBottom = () => {
		const tableBody = document.querySelector('.ant-table-body') as HTMLElement;
		if (tableBody) {
			tableBody.scrollTo({
				top: tableBody.scrollHeight,
				behavior: 'smooth',
			});
		}
	};

	// 4. Update the useEffect to listen to the table body scroll
	useEffect(() => {
		const tableBody = document.querySelector('.ant-table-body');
		if (tableBody) {
			tableBody.addEventListener('scroll', handleTableScroll);
			return () => {
				tableBody.removeEventListener('scroll', handleTableScroll);
			};
		}
	}, [costAllocationData]);

	return (
		<>
			{columns ? (
				<div
					className="cost-allocation-table"
					data-tour-target="tutorial-cost-allocation-table"
				>
					<SearchAndFilter
						searchValue={searchValue}
						performSearchHandler={(value: any) => {
							setSearchValue(value);
							setApplySearch(true);
						}}
						onChangePayPeriod={(id: any) => {
							setPayPeriodId(id);
							localStorage.setItem('payPeriod', id as string);
							setApplySearch(true);
							setQueryParams({ payPeriod: id });
						}}
						selectedPayPeriod={payPeriodId}
						filterValue={filterValue}
						performFilterHandler={(key: any, value: any) => {
							setFilterValue({ ...filterValue, [key]: value });
							setApplySearch(true);
						}}
						clearFilter={() => {
							setApplySearch(true);
							setSortBy('');
							setSortType('');
							setSearchValue('');
							setFilterValue({});
						}}
						sortBy={sortBy}
						sortType={sortType}
						isCostAllocation={isCostAllocation}
						onScreenChange={onScreenChange}
						isExpanded={isExpanded}
					/>
					{classReferenceIssues.length > 0 && (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								background: '#fffbe6',
								border: '1px solid #ffe58f',
								borderRadius: '6px',
								padding: '10px 16px',
								margin: '10px 0',
								fontSize: '13px',
							}}
						>
							<span>
								<WarningOutlined style={{ color: '#faad14' }} />
								&nbsp;{staleClassEmployeeIds.size} employee(s) have an outdated
								class reference in QuickBooks and may fail to publish.
							</span>
							<button
								onClick={() => setIsResolveModalOpen(true)}
								style={{
									border: 'none',
									background: 'none',
									color: '#344734',
									fontWeight: 600,
									textDecoration: 'underline',
									cursor: 'pointer',
								}}
							>
								Resolve
							</button>
						</div>
					)}
					<Table
						dataSource={dataSource}
						scroll={{ y: 'calc(87vh - 315px)' }}
						pagination={false}
						ref={tableScrollRef}
						rowKey={(record: any) => {
							return record.id;
						}}
						sticky
						footer={() => {
							return (
								<div className="cost-allocation-footer">
									{/* <NumericFormat
									value={grandTotal || 0}
									thousandSeparator=","
									decimalScale={configurationsData?.decimalToFixedAmount || 2}
									fixedDecimalScale={true}
									displayType="text"
									prefix="Grand Total: $"
									renderText={(_value) => (
										<h4
											className={styles['dynamic-table-total']}
										>
											{_value ?? 0}
										</h4>
									)}
								/> */}
								</div>
							);
						}}
						className="cost-allocation"
						rowClassName={(record: any) => {
							if (record.type === 'total') {
								return 'cost-allocation-row';
							} else if (record.type === 'grandTotal') {
								return 'cost-allocation-total-row';
							}
							return '';
						}}
						loading={{
							spinning: !costAllocationData,
							indicator: (
								<div
									style={{
										textAlign: 'center',
										padding: '50px 20px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										flexDirection: 'column',
										minWidth: '200px',
										marginLeft: '-105px',
										marginTop: '5px',
									}}
								>
									<Spin
										indicator={
											<LoadingOutlined
												spin
												style={{ color: '#485949', fontSize: '30px' }}
											/>
										}
										className="custom-spinner"
									/>
									<div
										style={{
											fontSize: '16px',
											color: '#485949',
											fontWeight: '600',
											minHeight: '20px',
											transition: 'opacity 0.3s ease-in-out',
											whiteSpace: 'nowrap',
											textAlign: 'center',
											paddingTop: '40px',
											marginLeft: '14px',
										}}
									>
										{currentLoadingMessage}
									</div>
								</div>
							),
						}}
						onChange={tableChangeHandler}
						locale={{
							emptyText: <CustomEmptyState />
						}}
					>
						{employeeRowSpanMapping &&
							columns?.map((singleColumn: any) => {
								return (
									<Column
										title={() => {
											return (
												<Tooltip>
													<div className="cost-allocation-column-title">
														<p>{singleColumn.svg}</p>
														{/* Apply WrappingEllipse to ALL columns */}
														<WrappingEllipse
															message={singleColumn?.title}
															maxLength={60} // Adjust based on your needs
															maxLines={3} // Allow up to 2 lines before truncating
															isTooltip={true}
															tooltipMessage={singleColumn?.title}
														/>
													</div>
												</Tooltip>
											);
										}}
										className={`${singleColumn.isSectionLastColumn && 'last-column'
											}`}
										showSorterTooltip={{ title: '' }}
										defaultSortOrder={singleColumn.defaultSortOrder}
										sorter={singleColumn.sorter}
										sortDirections={singleColumn.sortDirections}
										sortIcon={singleColumn.sortIcon}
										dataIndex={singleColumn?.dataIndex}
										key={singleColumn?.key}
										fixed={
											FIXED_COLUMNS.includes(singleColumn?.fieldName) && 'left'
										}
										width={singleColumn?.width}
										onCell={(record: any) => {
											let rowSpan = 1;
											let className = `${singleColumn.className} ${singleColumn.isSectionLastColumn && 'last-column'
												} ${singleColumn.cellColor}`;

											if (singleColumn?.dataIndex === 'employee-name') {
												rowSpan = employeeRowSpanMapping[
													record[
													'employee-name'
													] as keyof typeof employeeRowSpanMapping
												]
													? employeeRowSpanMapping[
													record[
													'employee-name'
													] as keyof typeof employeeRowSpanMapping
													]
													: 0;
											}

											if (record?.type === 'total') {
												className = `${singleColumn.className} total-row`;
											}

											return {
												rowSpan: rowSpan,
												className,
											};
										}}
										render={(value: string, record: any) => {
											return singleColumn?.fieldType === 'Text' ? (
												<div
													className={styles['dynamic-table__employee-name']}
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
													}}
												>
													<div
														onClick={() => {
															setShowWarningModel(true);
														}}
													>
														{value?.includes('Total') ? <b>{value}</b> : value}
													</div>
													{singleColumn?.dataIndex === 'employee-name' &&
														record['total-hours'] == '-' &&
														!value?.includes('Total') && (
															<div
																style={{
																	cursor: 'pointer',
																}}
																onClick={() => {
																	setISConfigModalOpen(true);
																	setSelectedEmployeeConfig({
																		id: record.employeeId,
																		name: record['employee-name'],
																	});
																}}
															>
																<Tooltip title="Set employee direct allocation">
																	<PercentageOutlined />
																</Tooltip>
															</div>
														)}
													{singleColumn?.dataIndex === 'employee-name' &&
														!value?.includes('Total') &&
														staleClassEmployeeIds.has(record.employeeId) && (
															<div
																style={{ cursor: 'pointer' }}
																onClick={() => setIsResolveModalOpen(true)}
															>
																<Tooltip title="This employee has an outdated class reference in QuickBooks — click to resolve">
																	<WarningOutlined style={{ color: '#faad14' }} />
																</Tooltip>
															</div>
														)}
												</div>
											) : (
												<div className={styles['dynamic-table__status']}>
													{singleColumn.isSectionLastColumn ||
														record.type === 'grandTotal' ||
														record.type === 'total' ||
														// singleColumn.dataIndex === 'indirect-allocation' ||
														(Array.isArray(singleColumn.dataIndex) &&
															singleColumn.dataIndex[0]?.startsWith(
																'indirect-allocation-'
															)) ||
														record['total-hours'] != '-' ? (
														<NumericFormat
															value={value}
															thousandSeparator=","
															decimalScale={
																configurationsData?.decimalToFixedAmount || 2
															}
															fixedDecimalScale={true}
															displayType="text"
															prefix="$"
															renderText={(_value) => (
																<h4
																	className={styles['dynamic-table-total']}
																	style={{
																		textAlign: 'right',
																	}}
																	onClick={() => {
																		setShowWarningModel(true);
																	}}
																>
																	{_value ?? 0}
																</h4>
															)}
														/>
													) : (
														<NumericFormat
															allowNegative={true}
															allowLeadingZeros={true}
															decimalScale={
																configurationsData?.decimalToFixedAmount || 2
															}
															fixedDecimalScale={true}
															thousandSeparator=","
															customInput={Input}
															value={value}
															className={
																singleColumn.cellWidth === 130
																	? 'width-130'
																	: 'width-120'
															}
															min={0}
															style={{ textAlign: 'end' }}
															size="large"
															prefix={'$'}
															disabled={
																!(
																	isEditEmployeeCostPermission ||
																	isAddEmployeeCostPermission
																)
															}
															onValueChange={(values: any) => {
																handleOnValueChange(
																	singleColumn?.dataIndex,
																	values?.floatValue,
																	record
																);
															}}
															onBlur={() => {
																handleInputBlur(
																	singleColumn?.dataIndex,
																	value,
																	record
																);
															}}
															onFocus={() => {
																handleOnFocus(record, singleColumn?.dataIndex);
															}}
														/>
													)}
												</div>
											);
										}}
									/>
									// )
								);
							})}
					</Table>
					{showScrollToBottom && (
						<div
							style={{
								position: 'fixed',
								right: '60px',
								bottom: '100px',
								zIndex: 1000,
							}}
						>
							<button
								onClick={scrollToBottom}
								style={{
									width: '48px',
									height: '48px',
									borderRadius: '50%',
									border: '1px solid #344734',
									padding: 0,
									margin: 0,
									backgroundColor: '#fff',
									color: '#344734',
									cursor: 'pointer',
									boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									fontSize: '32px',
									fontWeight: 'bold',
									transition: 'all 0.3s ease',
									outline: 'none',
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor = '#344734';
									e.currentTarget.style.color = '#fff';
									e.currentTarget.style.transform = 'scale(1.1)';
									e.currentTarget.style.boxShadow =
										'0 6px 16px rgba(52, 71, 52, 0.3)';
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor = '#fff';
									e.currentTarget.style.color = '#344734';
									e.currentTarget.style.transform = 'scale(1)';
									e.currentTarget.style.boxShadow =
										'0 4px 12px rgba(0, 0, 0, 0.15)';
								}}
								title="Scroll to bottom"
							>
								<DownCircleOutlined />
							</button>
						</div>
					)}
					<p style={{ color: '#818181', padding: '10px', fontSize: '12px' }}>
						Note: Editing the value will affect the allocation percentages.
					</p>
				</div>
			) : (
				<div
					style={{
						position: 'fixed',
						top: 'calc(48vh + 70px)',
						left: 'calc(48vw + 150px)',
					}}
				>
					<Loader />
				</div>
			)}
			<MessageModal
				isModalOpen={showWarningModel}
				message="The values on this report are read only. To edit these values, please go to the Employee Cost page and/or the Time Activity page."
				handleCancel={() => {
					setShowWarningModel(false);
				}}
			/>
			{showInputEditWarningModel && (
				<InputEditWarningModal
					isOpen={showInputEditWarningModel}
					onCancel={() => handleCancel()}
					onProceed={() => handleProceed()}
					data={''}
					type="Default"
					isLoading={isLoading}
				/>
			)}

			{increaseValueWarningModel && (
				<InputEditWarningModal
					isOpen={increaseValueWarningModel}
					onCancel={() => handleUpdateCostCancel()}
					onProceed={() => handleUpdateCostProceed()}
					data={currentChangeDetails}
					type="CostUpdate"
					isLoading={isLoading}
				/>
			)}

			{infoWarningModel && (
				<InputEditWarningModal
					isOpen={infoWarningModel}
					onCancel={() => handleInfoCancel()}
					onProceed={() => handleInfoProceed()}
					data={currentChangeDetails}
					type="Info"
					isLoading={isLoading}
				/>
			)}

			{configurationMismatchModel && (
				<InputEditWarningModal
					isOpen={configurationMismatchModel}
					onCancel={() => handleConfigurationMismatchCancel()}
					onProceed={() => handleConfigurationMismatchProceed()}
					data={currentChangeDetails}
					type="configurationMismatch"
					isLoading={isLoading}
				/>
			)}
			{openCostAllocationDifferenceModal ? (
				<CostAllocationDifferenceModal
					isOpen={openCostAllocationDifferenceModal}
					onCancel={() => setOpenCostAllocationDifferenceModal(false)}
					data={costAllocationDifferenceData}
					onConfigure={() => handleConfigure()}
				/>
			) : null}
			{isConfigModalOpen ? (
				<EmployeeConfigModal
					open={isConfigModalOpen}
					onCloseModal={() => setISConfigModalOpen(false)}
					selectedEmployee={selectedEmployeeConfig}
					onConfigured={() => {
						setISConfigModalOpen(false);
						getCostAllocationData();
					}}
					isClassRequiredForJournal={
						configurationsData?.isClassRequiredForJournal
					}
					isCustomerRequiredForJournal={
						configurationsData?.isCustomerRequiredForJournal
					}
				/>
			) : null}
			{isResolveModalOpen && (
				<ResolveClassReferencesModal
					open={isResolveModalOpen}
					onClose={() => setIsResolveModalOpen(false)}
					companyId={localStorage.getItem('companyId') as string}
					payPeriodId={payPeriodId as string}
					onResolved={() => {
						getClassReferenceStatus();
						getCostAllocationData();
					}}
				/>
			)}
		</>
	);
};

export default DynamicTable;
